module.exports = __webpack_public_path__ + "static/inspirandoMentes-41bb8081fa75d687be08952d040c8669.png";